import React, { useEffect, useState } from "react";
import "./PaymentConfirmPage.css";
import verifiedLogo from "./image/verified-logo.png";
import foodImg from "./image/food-img.png";

import { RiArrowDropDownLine } from "react-icons/ri";
import { SlCalender } from "react-icons/sl";
import { IoMdStopwatch } from "react-icons/io";
import { TbUsers } from "react-icons/tb";
import { IoLocationOutline } from "react-icons/io5";
import { GiNotebook } from "react-icons/gi";
import { GiSandsOfTime } from "react-icons/gi";
import { Link } from "react-router-dom";
import EventsListingCard from "../event-view-all-page/EventsListingCard";
import FaqSection from "../FAQ/FaqSection";

import cardImage1 from "../event-view-all-page/image/event-image-1.png"
import cardImage2 from "../event-view-all-page/image/event-image-2.png"
import cardImage3 from "../event-view-all-page/image/event-image-3.png"
import cardImage4 from "../event-view-all-page/image/event-image-4.png"

import axios from 'axios';



const eventsData = [
    {
        "title": "Percussion Night by The Drum Group - Gurugram",
        "date": "March 22",
        "time": "7 PM",
        "rating": "4.9",
        "location": "Veggies Garden Palace, DLP Phase 3",
        "distance": "1.2 Kms",
        "type": "Indoors",
        "price": "1499-1999 for 2 people",
        "image": cardImage1,

    },
    {
        "title": "Sitar Magic by Rishabh Rikhiram Sharma - Gururam",
        "date": "March 24",
        "time": "8 PM",
        "rating": "4.7",
        "location": "Sky High Lounge, CP",
        "distance": "3.5 Kms",
        "type": "Outdoors",
        "price": "999-1499 for 2 people",
        "image": cardImage2,
        "offer": "60% off offer in last 30 days"

    },
    {
        "title": "Bollywood Music Night - Noida",
        "date": "March 28",
        "time": "9 PM",
        "rating": "4.6",
        "location": "Wave City Center, Noida",
        "distance": "5.0 Kms",
        "type": "Indoors",
        "price": "1299-1799 for 2 people",
        "image": cardImage3,


    },
    {
        "title": "Bollywood Music Night - Noida",
        "date": "March 28",
        "time": "9 PM",
        "rating": "4.6",
        "location": "Wave City Center, Noida",
        "distance": "5.0 Kms",
        "type": "Indoors",
        "price": "1299-1799 for 2 people",
        "image": cardImage4,
    }
]

const url = "https://partywitty.com/master/assets/uploads/";


export default function PaymentConfirmPage() {
    const [eventsData, setEventData] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);

        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();

        // Helper to get ordinal suffix
        const getOrdinal = (n) => {
            if (n > 3 && n < 21) return 'th';
            switch (n % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };

        return `${day}${getOrdinal(day)}, ${month} ${year}`;
    };



    const fetchUpcomingEvents = async (lat, lng, date) => {
        try {
            const formData = new FormData();
            formData.append('latitude', lat);
            formData.append('longitude', lng);
            formData.append('date', date);

            const response = await axios.post(
                'https://partywitty.com/master/APIs/ClubEvent/upcomingEvents',
                formData
            );

            if (response.data.status === true) {
                console.log('Upcoming Events:', response.data.data);
                setEventData(response.data.data); // ✅ Save to state
            } else {
                console.warn('No events found:', response.data.msg);
                setEventData([]); // Clear if no events
            }
        } catch (error) {
            console.error('Error fetching upcoming events:', error);
            setEventData([]);
        }
    };

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const latStr = latitude.toString();
                    const lngStr = longitude.toString();

                    setLatitude(latStr);
                    setLongitude(lngStr);

                    fetchUpcomingEvents(latStr, lngStr, today);
                },
                (error) => {
                    alert('Please enable Geo Location Service to find events in your locality.');
                    console.error('Error in finding location:', error);
                }
            );
        } else {
            console.error('Geolocation is not available in this browser.');
        }
    }, []);



      function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        return `/event/${format(clubName)}-${format(cityName)}-${format(areaName)}-${format(title)}`;
    }


    return (
        <div className="payment-confirm-page">
            <div className="payment-cone-container">
                <div className="payment-card-c">
                    <div className="success-icon-c"><img src={verifiedLogo} alt="" /></div>
                    <h2 className="success-text-c">Payment Successful!</h2>

                    <div className="booking-status-container-c">
                        <div className="booking-status-c">
                            <p><span className="status-icon-c"><GiSandsOfTime size={25} /></span>  Waiting for Booking Confirmation<br /></p>
                            <div className="status-text-c">
                                <p>
                                    We’ve notified <a href="#">Veggies Garden Palace</a> about your
                                    booking. You’ll receive a confirmation once the restaurant accepts
                                    your request.
                                </p>
                            </div>
                        </div>

                        <div className="summary-section-c">
                            <div className="summary-header-c">
                                <span className="summary-title-c">📋 View Party Summary</span>
                                <RiArrowDropDownLine size={25} />
                            </div>
                            <div className="summary-body-c">
                                <img
                                    src={foodImg}
                                    alt="Party"
                                    className="summary-image-c"
                                />
                                <div className="summary-cetails-c">
                                    <h4>Pure Vegetarian Food Party</h4>
                                    <p className="venue-c">Veggies Garden Palace</p>
                                    <p><SlCalender /> 14 April 2025</p>
                                    <p><IoMdStopwatch /> 10PM - 1AM</p>
                                    <p><TbUsers /> 4 Guests</p>
                                    <p><IoLocationOutline /> Block K, Lajpat Nagar IV, Lajpat Nagar, New Delhi, Delhi 110048</p>
                                    <div className="badge-group-c">
                                        <span className="badge-c">Get Directions</span>
                                        <span className="badge paid-c">Amount Paid ₹ 2010</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="note-c">
                        <button>Continue For Add Menu</button>
                    </div>
                </div>
            </div>
            <div className="event-happening-title">
                <h1>Events happening on {formatDate(today)}</h1>
                <Link to='/events'>
                    <p>view all</p>
                </Link>
            </div>
            <div className="event-cards-container">
                {eventsData.slice(0, 3).map((event, index) => (
                    <Link to={generateClubUrl(event.clubName, event.cityName, event.areaName, event.name)}>
                    <EventsListingCard title={event.name} date={event.event_date} time={event.event_time} rating={event.rating} location={event.cityName} distance={event.distance} type={event.categoryName} price={event.min_price} image={url + event.image} offer={event.offer} />
                    </Link>
                ))}
            </div>
            <div>
                <FaqSection />
            </div>

        </div>
    );
}
